// 此文件为声明请求所用
import service from './axios'
import qs from 'qs'

// 主页轮播图
export function getHomeBannerPage (data) {
  return service.get(`/guet/website/get_home_banner_page?${qs.stringify(data)}`)
}

// 团队详情
export function getTeamDetail () {
  return service.get(`/guet/website/get_team_detail`)
}

// 通知公告
export function getNoticePage (data) {
  return service.get(`/guet/website/get_notice_page?${qs.stringify(data)}`)
}

// 查询发表论文表列表
export function listPublication (data) {
  return service.get(`/guet/website/list_publication?${qs.stringify(data)}`)
}

// 查询发表论文分页列表
export function getPublicationPage (data) {
  return service.get(`/guet/website/get_publication_page?${qs.stringify(data)}`)
}

// 查询团队生活列表
export function getTeamLifePage (data) {
  return service.get(`/guet/website/get_team_life_page?${qs.stringify(data)}`)
}

// 查询招聘信息列表
export function listHire (data) {
  return service.get(`/guet/website/list_hire?${qs.stringify(data)}`)
}

// 查询专利列表
export function listPatent (data) {
  return service.get(`/guet/website/list_patent?${qs.stringify(data)}`)
}

// 查询实验设备分页列表
export function getDevicePage (data) {
  return service.get(`/guet/website/get_device_page?${qs.stringify(data)}`)
}

// 查询小组成员列表
export function listGroupMember (data) {
  return service.get(`/guet/website/list_group_member?${qs.stringify(data)}`)
}

// 查询职位列表
export function listPosition (data) {
  return service.get(`/guet/website/list_position?${qs.stringify(data)}`)
}

// 查询文章详情
export function getArticleDetail (data) {
  return service.get(`/guet/website/get_article_detail?${qs.stringify(data)}`)
}

export function getAcademicTrendPage (data) {
  return service.get(`/guet/website/get_academic_trend_page?${qs.stringify(data)}`)
}



// WEBPACK FOOTER //
// ./src/api/api.js